import { createGlobalStyle } from "styled-components";

// https://basscss.com/#basscss-padding

const GlobalStyles = createGlobalStyle`
  html {
    font-family: 'Open Sans', Helvetica, sans-serif;
    font-weight: 300;
    letter-spacing: .03em;
    scroll-behavior: smooth;
    transition:0.2s;
  }
  body {
    margin: 0;
    padding: 0;
    min-height: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.text}; 
    overflow-x: hidden;
  }
  @media screen and (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }
  }
  
  *:focus { outline: ${({ theme }) => theme.colors.nero}; }
  *::selection { background: ${({ theme }) => theme.colors.tangerine};}

  body::-webkit-scrollbar {
    width: 10px;
    background-color: #424242;
  }

  body::-webkit-scrollbar-track {
      background-color: #424242;
  }

  body::-webkit-scrollbar-thumb {
      background-color: #8e8e8e;
      border-radius: 0px
  }

  img { 
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
  } 
  p {
    font-size: 19px;
    max-width: ${({ theme }) => theme.other.readable}px;
    font-size: 16px;
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
      font-size: 19px;
    }
    margin-bottom: 15px;
    line-height: 2.2em;
  }
  strong {
    max-width: ${({ theme }) => theme.other.readable}px;
    font-size: 16px;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
      font-size: 19px;
    }
    font-weight: 600;
    line-height: 2.4em;
    margin-bottom: 15px;
  }
  .subTitle {
    font-size: 18px;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
      font-size: 21px;
    }
    min-height: ${({ theme }) => theme.spacing.large};
    font-weight: 400;
    line-height: 2.1em;
    margin: 0 auto 15px auto;
  }
  .smallText {
    font-size: 15px;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
      font-size: 17px;
    }
  }
  h1 {
    margin: 0.6em auto 0.5em auto;
    text-align: center;
    padding: 10px;
    font-weight: 300;
    line-height: 1;
    font-size: 48px;
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
      font-size: 72px;
    }
  }
  h2 {
    margin: 0.3em auto 1em auto;
    text-align: center;
    font-weight: 300;
    padding: 10px;
    max-width: ${({ theme }) => theme.other.readable}px;
    font-size: 2em;
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
      font-size: 3em;
    }
    max-width: 80vw;
    line-height: 1.5em;
  }
  h2.subTitle {
    max-width: ${({ theme }) => theme.other.readable}px;
    margin: 0 auto 15px auto;
    font-size: 36px;
    @media (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
      font-size: 48px;
    }
    font-weight: 500;
    line-height: 1.3em;
  }
  h3 {
    max-width: ${({ theme }) => theme.other.readable}px;
    margin: 0 auto 15px auto;
    font-weight: 500;
    font-size: 1.2rem;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
      font-size: 1.8rem;
    }
    padding: 0px;
  }

  ol, ul {
    max-width: ${({ theme }) => theme.other.readable}px;
    font-size: 16px;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
      font-size: 19px;
    };
    line-height: 2.2em;
    padding: 0px 0px 0px 32px;
    list-style: square !important;
  }
  .regular {
    font-weight: 400;
  }
  .large {
    font-weight: 600;
  }
  .center { margin-right: auto; margin-left: auto; }
  h2.center {
    margin: 10px auto;
  }
  .block { display: block; }
  .white { color: white; }
  .tc  { text-align: center; }
  .m0 { margin: 0; }
  .mla { margin-left: auto; }
  .mra { margin-right: auto; }
  .ml0 { margin-left: 0; }
  .mr0 { margin-right: 0; }
  .mb0 { margin-bottom: 0; }
  .mb1 { margin-bottom: ${({ theme }) => theme.spacing.extraEmall}; }
  .mb2 { margin-bottom: ${({ theme }) => theme.spacing.small}; }
  .mb3 { margin-bottom: ${({ theme }) => theme.spacing.medium}; }
  .mb4 { margin-bottom: ${({ theme }) => theme.spacing.large}; }
  .mb5 { margin-bottom: ${({ theme }) => theme.spacing.extraLarge}; }
  .mt0 { margin-top: 0; }
  .mt1 { margin-top: ${({ theme }) => theme.spacing.extraEmall}; }
  .mt2 { margin-top: ${({ theme }) => theme.spacing.small}; }
  .mt3 { margin-top: ${({ theme }) => theme.spacing.medium}; }
  .mt4 { margin-top: ${({ theme }) => theme.spacing.large}; }
  .mt5 { margin-top: ${({ theme }) => theme.spacing.extraLarge}; }
  .titleSpacing { 
    margin: 0.5em auto 0.7em;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
      margin: 0.5em auto 1.4em;
    };
  }
  .container {
    margin: 0 auto;
    max-width: 1080px;
    position: relative;
    width: 100%;
    padding: 1em 25px 1em 25px;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
      padding: 2.5em 30px 2.5em 30px;
    }
  }
  .container.big {
    padding: 5.5em 30px 3.5em 30px;
  }
  .container.small {
    padding: 1em 30px 0em 30px;
  }
  section {
    width: 100%;
    position: relative;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    display: flex;
    h1, h2 {
      max-width: 70%;
    }
  }
  main {
    section:first-of-type {
      padding-top: 60px;
    }
    section.hero {
      min-height: 30vh;
      color: black;
      background: ${(props) => props.theme.colors.monteCarlo}; 
      @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
        min-height: 50vh;
      }
    }
    section.bg-cerulean {
      color: white;
      background: ${(props) => props.theme.colors.cerulean}; 
    }
    section.bg-smoke {
      background: ${(props) => props.theme.colors.smoke}; 
    }
  }
  .readable { max-width: ${({ theme }) => theme.other.readable}px; } 
`;

export { GlobalStyles };